export default "__VITE_ASSET__B$SvkFbL__"